export const environment = {
  production: false,
  apiEndpoint: 'https://fdplan-redms-api-dev3.azure.chevron.com/api',
  simulationApiEndpoint: 'https://fdplan-redms-sim-dev3-cvx.azurewebsites.net/api',
  apiFailureRetryCount: 3,
  apiFailureRetryDelayInSeconds: 2,
  refreshTokenFailureRetryDelayInSeconds: 10,
  refreshTokenIntervalInMillis: 5 * 60 * 1000,
  maxFileUploadChunkSize: 4 * 1024 * 1024,
  maxFileUploadsConcurrently: 3,
  maxFileChunkUploadsConcurrently: 3,
  calTenantId: 'fd799da1-bfc1-4234-a91c-72b3a1cb9e26',
  calClientId: 'cc496df7-0627-4564-8fa8-be1c14c82e4b',
  simulationLink: 'https://api.delfi.slb.com/reservoir-engineering/simulations/v1/simulations/',
  webEditorUrl: 'https://fdplan-redms-webixc-dev.azure.chevron.com/vs/basic-editor.html',
  webDiffEditorUrl: 'https://fdplan-redms-webixc-dev.azure.chevron.com/vs/diff.html',
  pageSizeOptions: [10,25,50,100],
  redmsDateTimeFormat: "MM/DD/YYYY HH:mm:ss",
  viewableExtensions: ['manifest', 'afi', 'csv', 'ixf', 'py', 'txt', 'json'],
  editableExtensions: ['afi', 'csv', 'ixf', 'py', 'txt', 'json'],
  appInsights: {
    instrumentationKey: 'dd1c9c42-92a9-4b46-8b7c-06edc1a700b0'
  },
  minSimUploadProgress: 5,
  maxSimUploadProgress: 95,
  fileUploadProgressComplete: 70.0,
  usePollingApi: true, 
};
